<template>
  <div class="zj-demo-chart">
    <zj-layout-container>
      <zj-layout-header>
        <h1 style="margin: 0rem 6rem;">基于消息通知的聊天室示例</h1>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable" ref="container">
          <ul class="zj-demo-chart-msg-list">
            <li v-for="msg in msgList" :key="msg.id">{{msg.content}}</li>
          </ul>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <div style="margin: 2rem 2rem;">
          <!-- 语音 -->
          <i class="el-icon-microphone" @click="handleBtnClick"></i>
          <!-- <audio controls autoplay id="audio"></audio> -->
          <ButtonGroup size="small">
            <!-- <Button @click="play_mp3">播放</Button> -->
            <Button @click="send_voice">发送</Button>
            <Button @click="cancel_mp3">停止</Button>
            <!-- <Button @click="cancel">取消</Button> -->
          </ButtonGroup>
        </div>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import ZJApp from "../../../../app";
import axios from "axios";
import Recorderx, { ENCODE_TYPE } from "recorderx";
const rc = new Recorderx();
export default {
  name: "ZjDemoVoiceChat",
  controller: "UI",
  action: "VoiceChat",
  data() {
    return {
      maxId: 1,
      sender: "Web",
      text: "您好, Web!!!",
      msgList: [],
      content: "", //聊天信息
      chatList: [], //聊天信息展示数据
      uploadData: {
        module: "SOS", //模块名
        submodule: "WAV", //子模块
        assocID: "", //业务ID
        uploader: ZJApp.ZJUser.current.UserName, //上传人
        folder: "/SOS/AudioFiles", //上传目录，服务器按如下格式拼装：/{module}/{submodule}/{folder}
        ext1: "", //扩展字段 1
        ext2: "", //扩展字段 2
        ext3: 0 //扩展字段 3
      }
    };
  },

  destroyed() {},
  computed: {
    httpRequest() {
      return ZJApp.ZJApis.ZJUploader.upload;
    }
  },
  methods: {
    //录制语音  获取麦克风权限
    handleBtnClick: function() {
      let that = this;
      // that.news_img = !that.news_img
      rc.start()
        .then(() => {
          that.news_img = !that.news_img;
          console.log("start recording");
        })
        .catch(error => {
          alert("获取麦克风失败");
          console.log("Recording failed.", error);
        });
    },
    //暂停语音
    cancel_mp3: function() {
      rc.pause();
    },
    //取消语音
    // cancel: function() {
    //   rc.clear();

    // },
    //播放语音
    // play_mp3:function(){
    //   var wav = rc.getRecord({
    //   encodeTo: ENCODE_TYPE.WAV,
    //   compressible: true
    // });
    // document.getElementById('audio').src = URL.createObjectURL(wav);
    // },
    //发送语音
    send_voice: function() {
      let that = this;
      var wav = rc.getRecord({
        encodeTo: ENCODE_TYPE.WAV,
        compressible: true
      });
      var uuid = this.uuid;
      this.uploadData.assocID = this.uuid;
      if (this.chatList != "") {
        var end_time = this.chatList[this.chatList.length - 1].addtime;
      }
      var formData = new FormData();
      // formData.append('file',wav);
      formData.append("topic_id", uuid);
      formData.append("last_time", end_time);
      formData.append("type", 4);
      formData.append("file", wav, Date.parse(new Date()) + ".wav");
      let headers = { headers: { "Content-Type": "multipart/form-data" } };
      var option = {
        file: formData,
        data: {
          module: "SOS", //模块名
          submodule: "Voice", //子模块
          assocID: uuid, //业务ID
          uploader: "H5" //上传人
        },
        onProgress: () => {},
        onSuccess: () => {},
        onError: () => {}
      };
      this.httpRequest(option);
      axios.defaults.withCredentials = true;
      axios
        .post(this.https + "/admin/api/send_reply", formData, headers)
        .then(data => {
          console.log(data);
          that.news_img = !that.news_img;
          // this.reload();
          rc.clear();
        })
        .catch(err => {
          console.log(err);
        });

      //  this.$request({
      //         url: "/api/send_reply",
      //         method: "post",
      //         data:formData,
      //        headers: {"Content-Type": "multipart/form-data"}
      //       }).then(data => {
      //           that.news_img = !that.news_img
      //           this.content = "";
      //         })
      //         .catch(err => {
      //           console.log(err);
      //         });
    }
  }
};
</script>

<style lang="scss" scoped>
ul.zj-demo-chart-msg-list,
ul.zj-demo-chart-button-bar {
  list-style: none;
  padding: 2rem 2rem;
  margin: 0;

  & > li {
    list-style: none;
    padding: 2rem 2rem;
    margin: 0;
  }
}
</style>